var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5415 5.33203C13.1372 5.33203 4.71191 13.7761 4.71191 24.1805C4.71191 34.5848 13.1372 43.0289 23.5415 43.0289C33.9647 43.0289 42.4088 34.5848 42.4088 24.1805C42.4088 13.7761 33.9647 5.33203 23.5415 5.33203ZM23.5603 39.2592C15.2293 39.2592 8.4816 32.5115 8.4816 24.1805C8.4816 15.8495 15.2293 9.10172 23.5603 9.10172C31.8913 9.10172 38.6391 15.8495 38.6391 24.1805C38.6391 32.5115 31.8913 39.2592 23.5603 39.2592ZM24.5028 14.7562H21.6755V26.0653L31.5709 32.0025L32.9845 29.6842L24.5028 24.6517V14.7562Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/RequestIcon.24425fca259fa83b1979cd11caf44ece.svg";
export { ForwardRef as ReactComponent };